import { TimePicker } from 'antd';
import React from 'react';

export const LCTimePicker =(props)=> <TimePicker {...props}/>;